import React from 'react';
import { HORSE_TYPES, GENDERS, AGE_RANGES, GALOPPO_LEVELS } from '../config/horseOptions';

export const FILTER_GROUPS = [
  { key: 'type', title: 'Tipo di cavallo', options: HORSE_TYPES },
  { key: 'gender', title: 'Sesso', options: GENDERS },
  { key: 'age', title: 'Età', options: AGE_RANGES },
  { key: 'galoppo', title: 'Galoppo', options: GALOPPO_LEVELS },
];

export const EMPTY_FILTERS = { type: [], gender: [], age: [], galoppo: [] };

const FilterGroup = ({ group, selected, onToggle, countFor, compact }) => (
  <div className={compact ? '' : 'mb-6'} data-testid={`filter-group-${group.key}`}>
    <h4 className={`font-medium uppercase tracking-wider text-[#64748b] ${compact ? 'text-xs mb-2' : 'text-sm mb-3'}`}>{group.title}</h4>
    <div className={compact ? 'space-y-1' : 'space-y-2'}>
      {group.options.map(o => (
        <label key={o.value} className="flex items-center gap-2 cursor-pointer group">
          <input
            type="checkbox"
            checked={selected.includes(o.value)}
            onChange={() => onToggle(group.key, o.value)}
            className={`${compact ? 'w-3.5 h-3.5' : 'w-4 h-4'} accent-[#c9a227]`}
            data-testid={`filter-${group.key}-${o.value}${compact ? '-mobile' : ''}`}
          />
          <span className={`${compact ? 'text-xs' : 'text-sm'} group-hover:text-[#c9a227] transition-colors`}>{o.label}</span>
          <span className="text-xs text-[#64748b] ml-auto">({countFor(group.key, o.value)})</span>
        </label>
      ))}
    </div>
  </div>
);

export const FilterPanel = ({ filters, onToggle, onReset, activeCount, countFor, compact }) => (
  <div className={`bg-white border border-gray-200 rounded-lg ${compact ? 'p-4 md:p-6' : 'p-6 sticky top-24'}`}>
    <div className={`flex items-center justify-between ${compact ? 'mb-4' : 'mb-6'}`}>
      <h3 className="font-display text-lg">Filtra</h3>
      {activeCount > 0 && (
        <button onClick={onReset} className="text-sm text-[#c9a227] hover:underline" data-testid={`filter-reset-btn${compact ? '-mobile' : ''}`}>
          Resetta ({activeCount})
        </button>
      )}
    </div>
    <div className={compact ? 'grid grid-cols-2 md:grid-cols-4 gap-4' : ''}>
      {FILTER_GROUPS.map(g => (
        <FilterGroup key={g.key} group={g} selected={filters[g.key]} onToggle={onToggle} countFor={countFor} compact={compact} />
      ))}
    </div>
  </div>
);
